import {
  ContentContainer,
  EventImage,
  EventVideo,
  HighlightText,
  ImageContainer,
  Paragraph,
  SectionContainer,
  Title,
} from './styles';
import { Column } from '@components/LinearLayout';
import Button from '@components/Button';
import { useTheme } from 'styled-components';
import { useDesktopWidth, useMobileWidth } from '@utils/hooks';

interface ImageAndTextSectionProps {
  orientation?: 'left' | 'right';
  sectionName: string;
  highlightText?: string;
  titleText: string;
  titleText2?: string;
  paragraphs: string[];
  imageURL?: string;
  buttonText?: string;
  buttonURL?: string;
  hasLogoOverlay?: boolean;
  logoOverlayImgSrc?: string;
  videoUrl?: string;
  maxImageHeight?: string;
  maxImageWidth?: string;
  maxContentWidth?: string;
}

export const ImageAndTextSection = ({
  orientation = 'left',
  sectionName,
  highlightText,
  buttonText,
  buttonURL,
  titleText,
  titleText2,
  paragraphs,
  maxImageHeight,
  maxImageWidth,
  maxContentWidth,
  videoUrl,
  imageURL,
}: ImageAndTextSectionProps) => {
  const theme = useTheme();
  const isDesktop = useDesktopWidth();
  const isMobile = useMobileWidth();

  const onClickHandler = () => {
    window.location.href = buttonURL ?? '';
  };

  return (
    <section>
      <SectionContainer orientation={orientation}>
        <ContentContainer maxWidth={maxContentWidth}>
          <Column $gap="1.5rem">
            <HighlightText>{highlightText}</HighlightText>
            <Title>
              {titleText} {titleText2 && <Title>{titleText2}</Title>}
            </Title>
            <Column $gap="3rem">
              {paragraphs.map((paragraph: string, index: number) => {
                return (
                  <Paragraph key={`paragraph-${sectionName}-${index}`}>
                    {paragraph}
                  </Paragraph>
                );
              })}

              {buttonText && (
                <Button
                  textColor={theme?.color?.white}
                  backgroundColor={theme?.color?.primary}
                  hoverBackgroundColor={theme.color.mobilityGrey}
                  title={buttonText}
                  fontSize={isDesktop ? '18px' : '20px'}
                  width={isDesktop ? '100%' : 'max-content'}
                  padding={isDesktop ? '1.5rem 2rem' : '1.1rem 3rem'}
                  borderRadius={isDesktop ? '5px' : '6px'}
                  onClick={onClickHandler}
                />
              )}
            </Column>
          </Column>
        </ContentContainer>
        <ImageContainer maxHeight={maxImageHeight} maxWidth={maxImageWidth}>
          {videoUrl ? (
            <EventVideo
              autoPlay={true}
              muted
              loop
              src={videoUrl}
              playsInline
              orientation={orientation}
              maxHeight={maxImageHeight}
            />
          ) : (
            <EventImage
              src={imageURL}
              alt={`${sectionName} - ${titleText}`}
              orientation={orientation}
              $height={maxImageHeight ?? '100%'}
            />
          )}
        </ImageContainer>
      </SectionContainer>
    </section>
  );
};
